import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./index.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
